export var main_button_joinTeam = {
    key: 'join::main_button_joinTeam',
    fallback: "Join Team"
};
export var main_button_loginToPreviousTeam = {
    key: 'join::main_button_loginToPreviousTeam',
    fallback: "Cancel and login"
};
export var main_checkbox_approval = {
    key: 'join::main_checkbox_approval',
    fallback: "I agree to join the new team's account"
};
export var main_checkbox_description = {
    key: 'join::main_checkbox_description',
    fallback: "By accepting the invite, you will be logged in to this team's account from now onwards."
};
export var main_checkbox_error = {
    key: 'join::main_checkbox_error',
    fallback: "You must first indicate that you agree to join the new account"
};
export var main_errors_alreadyMember = {
    key: 'join::main_errors_alreadyMember',
    fallback: "You're already a member of this team so you can just go ahead and login."
};
export var main_form_createUser = {
    key: 'join::main_form_createUser',
    fallback: "Create your PaymentsOS user"
};
export var main_form_joinTeam = {
    key: 'join::main_form_joinTeam',
    fallback: "Would you like to join the team?"
};
export var main_form_title = {
    key: 'join::main_form_title',
    fallback: "Join the team!"
};
export var main_subtitle_youveBeenInvited = {
    key: 'join::main_subtitle_youveBeenInvited',
    fallback: "You have been invited to join a new team"
};
export var main_title_welcomeBack = {
    key: 'join::main_title_welcomeBack',
    fallback: "Welcome back!"
};
